import { countryCodeToNameMap } from 'commons/types/dictionaries'
import { getState } from 'commons/utils'

export const Address = (props: {
  address?: string
  city?: string
  country: string
  state: string
  zipCode?: string
}) => {
  const { address, city, country, state, zipCode } = props

  return (
    <>
      {address !== undefined && <div>{address}</div>}
      <div>{[city, getState({ country, state }), zipCode].filter(Boolean).join(', ')}</div>
      <div>{countryCodeToNameMap[country]}</div>
    </>
  )
}
